import cx from 'classnames'
import { observer } from 'mobx-react-lite'

import IconButton from '@src/component/IconButton'
import type { RoomInvitationType } from '@src/service/transport/voice'
import type { ActiveCall } from '@src/service/voice'
import Typography from '@ui/Typography'
import { XIcon } from '@ui/icons/tint/20/general'

import * as styles from './CallHeader.css'

const getCallTypeText = (type: RoomInvitationType, isDirectCall: boolean) => {
  switch (type) {
    case 'called':
      return isDirectCall ? 'Team call' : 'Incoming call'
    case 'added':
      return 'Call invitation'
    case 'transferred':
      return 'Transfer request'
  }
}

interface CallHeaderProps {
  call: ActiveCall
  blurred: boolean
}

const CallHeader = ({ call, blurred }: CallHeaderProps) => {
  const handleDismiss = () => {
    call.dismiss()
  }

  return (
    <div className={cx(styles.root, { [styles.rootBlurred]: blurred })}>
      <div className={styles.phoneDetails}>
        <Typography variant="callout" className={styles.symbol}>
          {call.phoneNumber?.symbol}
        </Typography>
        <Typography nowrap variant="caption1" color="textPrimary" fontWeight="regular">
          {call.phoneNumber?.name}
        </Typography>
      </div>
      <Typography className={styles.type} variant="caption1" color="textSecondary">
        {call.invitation.type
          ? getCallTypeText(call.invitation.type, call.isDirectCall)
          : null}
      </Typography>
      {/* eslint-disable-next-line custom-rules/no-deprecated-buttons, @typescript-eslint/no-deprecated -- FIXME: https://linear.app/openphone/issue/UXP-4347/migrate-deprecated-buttons-to-ds-button */}
      <IconButton
        size={16}
        variant="transparent"
        color="gray"
        icon={<XIcon />}
        className={styles.dismissButton}
        title="Dismiss the call silently"
        tooltip={{
          themeKey: 'dark',
          colorScheme: 'call',
          placement: 'top',
        }}
        onClick={handleDismiss}
      />
    </div>
  )
}

export default observer(CallHeader)
